/** localStorage key prefix for GrowthBook sticky experiment assignments (post-consent only). */
export const GROWTHBOOK_STICKY_BUCKET_PREFIX = 'growthbook-experiments';

/** SDK default localStorage key for cached feature payloads. */
export const GROWTHBOOK_FEATURES_CACHE_KEY = 'gbFeaturesCache';

/** GrowthBook-only device id persisted only after consent is accepted. */
export const GROWTHBOOK_DEVICE_ID_KEY = 'growthbook-device-id';
